// extracted by mini-css-extract-plugin
export default {"green":"#6ad72f"};